import * as era from '!/era'
import { ui } from '!/skin'
import { Skeleton } from '@/ui/components/Skeleton'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { $contentLoading } from './skeleton'

const skin = era.skin('routes/library/purchased/liveEvents')

LibraryPurchasedLiveEventsPage.displayName = 'LibraryPurchasedLiveEventsPage'
export function LibraryPurchasedLiveEventsPage(): JSX.Element {
  const isContentLoading = useUnit($contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column`}>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='libraryPurchasedLiveEventsGrid' />
          <ui.RenderSkin name='libraryPurchasedLiveEventsEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
